module.exports = new __parcel__URL__("LitecoinLogo.f8fad246.svg").toString();